import {
  PERMISSION_SCOPE_TYPE,
  PERMISSION_SCOPE_ALL_TEAMS_ID
} from '@linearb/linjs-common';
import { allTeams } from 'connected-components/TopBar/TopBar.service';

// TO DO: when all teams group is GA delete this
const allTeamsScope = {
  scope_id: PERMISSION_SCOPE_ALL_TEAMS_ID,
  scope_type: PERMISSION_SCOPE_TYPE.ALL_TEAMS
};
export const getSelectedAccounts = ({ selectedAccountIds, accountsById }) =>
  selectedAccountIds.map(id => accountsById[id] || {});

// TO DO: when all teams group is GA delete this
export const isAllTeamsSelected = teamIds =>
  teamIds.length === 1 && teamIds[0] === allTeams.id;

// eslint-disable-next-line import/no-unused-modules
export const isAllTeamsGroupSelected = (selectedTeamIds, allTeamsGroupId) =>
  selectedTeamIds.length === 1 && selectedTeamIds[0] === allTeamsGroupId;

const isAllTeamsScope = (scopes = []) =>
  scopes.some(
    ({ scope_type }) => scope_type === PERMISSION_SCOPE_TYPE.ALL_TEAMS
  );

export const selectedTeamIdsToAccountScopes = (teamIds, allTeamsGroupId) =>
  isAllTeamsSelected(teamIds)
    ? [allTeamsScope]
    : teamIds.map(id => ({
        scope_type: isAllTeamsGroupSelected(teamIds, allTeamsGroupId)
          ? PERMISSION_SCOPE_TYPE.ALL_TEAMS
          : PERMISSION_SCOPE_TYPE.TEAM,
        scope_id: id
      }));

export const accountScopesToSelectedTeamIds = (scopes, isAllTeamsGroup) => {
  return isAllTeamsScope(scopes) && !isAllTeamsGroup
    ? [allTeams.id]
    : scopes.map(({ scope_id }) => scope_id);
};

export const HeaderTooltipContent = ({ accounts }) => (
  <div className='flex flex-col gap-2 h-28 w-48 overflow-auto'>
    <h3 className='text-md font-bold'>Selected Users</h3>
    {accounts?.map(({ name }, i) => (
      <div className='text-md' key={name + i}>
        {name}
      </div>
    ))}
  </div>
);
